export enum DialogOperationEnum {
  'Rename' = 'Rename',
  'NewFolder' = 'NewFolder'
}
